/**
 * TanStack Query hooks for `advertiser-payout-rules`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	listAdvertisers,
	remove,
	advertiserPayoutRulesQueryKeys,
	type AdvertiserOption,
	type CreateAdvertiserPayoutRulesBody,
	type ListAdvertiserPayoutRulesResponse,
	type AdvertiserPayoutRulesRow,
} from "./api";

export function useAdvertiserPayoutRulesList(): UseQueryResult<ListAdvertiserPayoutRulesResponse, Error> {
	return useQuery({
		queryKey: advertiserPayoutRulesQueryKeys.list(),
		queryFn: list,
	});
}

export function useAdvertiserPayoutRulesCreate(): UseMutationResult<AdvertiserPayoutRulesRow, Error, CreateAdvertiserPayoutRulesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserPayoutRulesQueryKeys.all });
		},
	});
}

export function useAdvertiserPayoutRulesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserPayoutRulesQueryKeys.all });
		},
	});
}

export function useAdvertisersList(): UseQueryResult<AdvertiserOption[], Error> {
	return useQuery({
		queryKey: advertiserPayoutRulesQueryKeys.advertisers(),
		queryFn: listAdvertisers,
	});
}
